import { network } from '@tencent/netcheck';
import { tencentDocOpenUrlReload } from '@tencent/tencent_doc_open_url';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import i18n from '@i18next/i18n';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';

function isMobile(ua = window.navigator.userAgent): boolean {
    return /mobile|android/i.test(ua);
}

export function checkClientVars() {
    const timer = setInterval(() => {
        if (window.clientVars || window.clientVarsException) {
            clearInterval(timer);
            // 断网数据请求异常符合预期，无需提示
            if (window.clientVarsException && network.isOnline) {
                const options = {
                    message: i18n.t('请求数据超时，请重试'),
                    commonTipsType: 'info',
                    autoClose: false,
                    action: [{
                        text: i18n.t('刷新'),
                        onClick: tencentDocOpenUrlReload,
                    }],
                };
                if (isMobile()) {
                    import('@tencent/dui-mobile/lib/components/Snackbar').then((dep) => {
                        // @ts-ignore
                        dep?.default?.()?.Snackbar?.show(options);
                    })
                        .catch((error) => {
                            window.log.error(`[loadChunk-error]${error}`);
                        });
                    return;
                }
                import('@tencent/dui/lib/components/Snackbar').then((dep) => {
                    // @ts-ignore
                    dep?.default?.()?.Snackbar?.show(options);
                })
                    .catch((error) => {
                        window.log.error(`[loadChunk-error]${error}`);
                    });
            }
        }
    }, 1000);
}

/**
 * 是否需要显示空白页
 */
export function needShowBlank(): boolean {
    let result = !SlideDataServices.PrivilegeManager()?.readable;
    const isEnableOfflineEditClient = browser.isTencentDocApp || browser.isTencentDocDesktopApp;
    if (isEnableOfflineEditClient) {
        result = false;
    }
    // 如果文档已经删除且不是文档的拥有者，则显示空白页。如果是文档的拥有者，则会弹窗【回收站中的文档不能编辑，如要使用请还原文档】
    result = (SlideDataServices.DocInfoManager()?.isDeleted && !SlideDataServices.DocInfoManager()?.isOwner) || result;
    return result;
}

// 是否为只读权限用户(只能查看)
export function isPreviewOnly(): boolean {
    const readable = SlideDataServices.PrivilegeManager()?.readable;
    const editable = SlideDataServices.PrivilegeManager()?.editable;
    return !!(readable && !editable);
}
